.empty-state-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
}
